import { Dispatch, SetStateAction, useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next";
import { categories } from "../../constants/categories";
import { translateCategorySlug } from "../../functions/translateCategorySlug";

interface ITableHeaderCategory {
	selected: {label: string, value: string} | null
	setSelected: Dispatch<SetStateAction<{label: string, value: string} | null>>
	scrollY: number
}

export default function TableHeaderCategory({ selected, setSelected, scrollY } : ITableHeaderCategory) {

	const { t } = useTranslation(), dropDownRef = useRef<HTMLDivElement>(null);


	const [isActive, setIsActive] = useState(false),
	intervalRef = useRef<any>(null),
	[x, setX] = useState(0);
	
	useEffect(() => {
		setIsActive(false);
	}, [selected])

	useEffect(() => {
		if(!dropDownRef.current) return;

		function onClick(event: MouseEvent) {
			if(!dropDownRef.current?.contains(event.target as Node)) {
				setIsActive(false);
			}
		}

		document.body.addEventListener("click", onClick);

		return () => document.body.removeEventListener("click", onClick);
	}, [dropDownRef]);

	useEffect(() => {
		if(!isActive && !dropDownRef.current) return;

		if(window.innerWidth > 992) {
			setX(0);
			return;
		}

		if(intervalRef.current) clearInterval(intervalRef.current);
		intervalRef.current = setInterval(() => {
			if(window.innerWidth <= 992) {
				setX((dropDownRef.current?.getBoundingClientRect().left || 0) - 15);
			} else {
				setX(0);
			}
		}, 100)
	}, [intervalRef, isActive])

	// prepare dropdown style to avoid complex inline templates (prevents parser issues)
	const dropdownStyle: React.CSSProperties = {
		minWidth: "220px",
		transform: `translateX(${x}px) translateY(${-scrollY}px)`
	};

	return (
		<div className="table-drop-down drop-down-absolute" ref={dropDownRef}>
			<button className={`table-drop-down__target drop-down-absolute__target${isActive ? " is-active" : ""}`} type="button" onClick={_ => setIsActive(prev => !prev)}>
				<span>
					{selected ? translateCategorySlug(t, selected.value) : t("timesheet_page.categories.Category")}
				</span>
				<svg width="10" height="7" viewBox="0 0 10 7" className="drop-down-absolute__target--arrow">
					<use xlinkHref="#drop-down-arrow"></use>
				</svg>
			</button>
		<div className={`table-drop-down__block drop-down-absolute__block${isActive ? " is-active" : ""}`} style={dropdownStyle}>
				<ul className="table-drop-down__list drop-down__list">
					<li>
						<button type="button" onClick={_ => setSelected(null)}>
							{t("timesheet_page.categories.All")}
						</button>
					</li>
					{categories.map(category => (
						<li key={category.value}>
							<button type="button" onClick={_ => setSelected(category)}>
								{translateCategorySlug(t, category.value)}
							</button>
						</li>
					))}
				</ul>
			</div>
		</div>
	)
}